/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CarveOutStatus } from './CarveOutStatus';
import {
    CarveOutStatusFromJSON,
    CarveOutStatusFromJSONTyped,
    CarveOutStatusToJSON,
} from './CarveOutStatus';

/**
 * 
 * @export
 * @interface CarveOutMedicationSummary
 */
export interface CarveOutMedicationSummary {
    /**
     * 
     * @type {string}
     * @memberof CarveOutMedicationSummary
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CarveOutMedicationSummary
     */
    medication_name: string;
    /**
     * 
     * @type {CarveOutStatus}
     * @memberof CarveOutMedicationSummary
     */
    status: CarveOutStatus;
    /**
     * 
     * @type {boolean}
     * @memberof CarveOutMedicationSummary
     */
    is_complete: boolean;
    /**
     * 
     * @type {number}
     * @memberof CarveOutMedicationSummary
     */
    cost_per_day?: number;
}

/**
 * Check if a given object implements the CarveOutMedicationSummary interface.
 */
export function instanceOfCarveOutMedicationSummary(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "medication_name" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "is_complete" in value;

    return isInstance;
}

export function CarveOutMedicationSummaryFromJSON(json: any): CarveOutMedicationSummary {
    return CarveOutMedicationSummaryFromJSONTyped(json, false);
}

export function CarveOutMedicationSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarveOutMedicationSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'medication_name': json['medication_name'],
        'status': CarveOutStatusFromJSON(json['status']),
        'is_complete': json['is_complete'],
        'cost_per_day': !exists(json, 'cost_per_day') ? undefined : json['cost_per_day'],
    };
}

export function CarveOutMedicationSummaryToJSON(value?: CarveOutMedicationSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'medication_name': value.medication_name,
        'status': CarveOutStatusToJSON(value.status),
        'is_complete': value.is_complete,
        'cost_per_day': value.cost_per_day,
    };
}

